import { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import magnifierImg from "src/img/magnifier.png";
import Resize from "src/components/common/resize";
import DataFilter from "src/components/common/frame/dataFilter";
import Footer from "src/components/common/frame/footer";
import { useMyStore } from "src/components/main/mainStore";
import {
    boolAndReducer, 
    isDevMode, 
    myAxios, 
    getTimeStamp, 
    plannedTimeExcel, 
    workLogSubmitTimeExcel, 
    appTitle
} from "src/components/common/functions";
import Export from "./export";
import UserInfo from "../common/userInfo";
//--------------------------------------------------------------------------------------------
export default function Approvals({ tabTitle }){
    const dataFrame = [
        {label: "Project Name", key: "projectName"}, 
        {label: "Project Category", key: "category"}, 
        {label: "Labor Category", key: "laborCategory"}, 
        {label: "Technician", key: "laborName"}, 
        {label: "Department", key: "department"}, 
        {label: "Submit Time", key: "workLogSubmitTime", type: "date"}, 
        {label: "Planned Start Time", key: "start", type: "date"}, 
        {label: "Planned End Time", key: "end", type: "date"}, 
    ];
    const defaultFilter = Object.fromEntries(dataFrame.map(item => [item.key, ""]));
    //--------------------------------------------------------------------------------------------
    // if(isDevMode) console.log("all");
    //--------------------------------------------------------------------------------------------
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const approvals = useMyStore(state => state.approvals);
    const setApprovals = useMyStore(state => state.setApprovals);
    //--------------------------------------------------------------------------------------------
    const history = useHistory();
    //--------------------------------------------------------------------------------------------
    const [updateDateTime, setUpdateDateTime] = useState({
        "Approvals": approvals.updatedAt === null?getTimeStamp():approvals.updatedAt
    });
    //--------------------------------------------------------------------------------------------
    const [showLoading, setShowLoading] = useState(false);
    const [curFilter, setFilter] = useState(defaultFilter);
    const [filterWords, setFilterWords] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    //--------------------------------------------------------------------------------------------
    const indexOfLastApproval = currentPage * itemsPerPage;
    const indexOfFirstApproval = indexOfLastApproval - itemsPerPage;
    const filteredApprovals = approvals.data.map(approval => ({
        ...approval, 
        plannedTimeExcel: plannedTimeExcel(approval.startTime, approval.endTime, approval.allDay), 
        workLogSubmitTimeExcel: workLogSubmitTimeExcel(approval.workLogSubmitTime)
    })).filter(approval => 
        (curFilter.projectName?approval.projectName === curFilter.projectName:true)
        && (curFilter.category?approval.category === curFilter.category:true)
        && (curFilter.laborName?approval.laborName === curFilter.laborName:true)
        && (curFilter.laborCategory?approval.laborCategory === curFilter.laborCategory:true)
        && (curFilter.department?approval.department === curFilter.department:true)
        && (curFilter.workLogSubmitTimeMin?approval.workLogSubmitTime >= curFilter.workLogSubmitTimeMin:true)
        && (curFilter.workLogSubmitTimeMax?approval.workLogSubmitTime <= curFilter.workLogSubmitTimeMax:true)
        && (curFilter.startMin?approval.startTime >= curFilter.startMin:true)
        && (curFilter.startMax?approval.startTime <= curFilter.startMax:true)
        && (curFilter.endMin?approval.endTime >= curFilter.endMin:true)
        && (curFilter.endMax?approval.endTime <= curFilter.endMax:true)
        && (filterWords.toLowerCase().split(" ").map(f => JSON.stringify(
            Object.values(approval)
        ).toLowerCase().indexOf(f) > -1).reduce(boolAndReducer, true))
    );
    const currentPageApprovals = filteredApprovals.slice(indexOfFirstApproval, indexOfLastApproval);
    const pageNumbers = Array.from({length: Math.ceil(filteredApprovals.length / itemsPerPage)}, (_, i) => (i + 1));
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        if(updateDateTime["Approvals"] === approvals.updatedAt) return;
        let isMounted = true;
        const controller = new AbortController();
        const getItems = async () => {
            if(isDevMode) console.log("useEffect");
            //-------------------------------------------------
            setShowLoader(true);
            setShowLoading(true);
            const res = await myAxios("approvals/readApprovals.php", undefined, undefined, controller.signal);
            if(!isMounted) return;
            setShowLoading(false);
            setShowLoader(false);
            if(!res) return;
            //-------------------------------------------------
            setApprovals(res.data, updateDateTime["Approvals"]);
        }
        getItems();
        return () => {
            isMounted = false;
            controller.abort();
            setShowLoader(false);
        }
    }, [updateDateTime, approvals.updatedAt, setApprovals, setShowLoader])
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //--------------------------------------------------------------------------------------------
    return(
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: user.userTheme}}>
                <span>
                    <Resize/>
                    {tabTitle}
                    <button
                        type = "button"
                        data-toggle = "tooltip"
                        title = {`Refreshed on ${Object.values(updateDateTime)[0]}.`}
                        className = "btn btn-primary ml-3"
                        onClick = {() => {
                            const timeStamp = getTimeStamp();
                            setUpdateDateTime(Object.fromEntries(Object.keys(updateDateTime).map(key => [key, timeStamp])));
                        }}
                    >
                        ↻
                    </button>
                </span>
                {approvals.data.length?<>
                <span>
                    <input
                        id = "searchBar"
                        className = "form-control w-auto"
                        type = "text"
                        value = {filterWords}
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                            setCurrentPage(1);
                        }}
                    />
                    <img alt = "" src = {magnifierImg}/>
                </span>
                <DataFilter
                    setCurrentPage = {setCurrentPage}
                    curFilter = {curFilter}
                    setFilter = {setFilter}
                    defaultFilter = {defaultFilter}
                    items = {approvals.data}
                    dataFrame = {dataFrame}
                    minWidth = {"70rem"}
                />
                </>:<></>}
                {filteredApprovals.length?
                <Export
                    filteredApprovals = {filteredApprovals}
                />:<></>}
            </div>
            <div className = {"cssContent" + (!showLoading && filteredApprovals.length?" pb10":"")}>
                {showLoading?<div className = "cssLoading">Loading...</div>:
                !currentPageApprovals.length?<div className = "cssLoading">Empty</div>:
                <div className = "table-responsive">
                <table className = "table">
                    <thead className = "noTableTopBorder">
                        <tr>
                            <th>Project Name</th>
                            <th>Project Category</th>
                            <th>Labor Category</th>
                            <th>Technician</th>
                            <th>Department</th>
                            <th>Submit Time</th>
                            <th>Planned Time</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentPageApprovals.map((approval, key) =>
                        <tr
                            key = {key}
                            className = "lineHeight2"
                        >
                            <td><Link to = {`/Projects/${approval.projectHashKey}`}>{approval.projectName}</Link></td>
                            <td>{approval.category}</td>
                            <td>{approval.laborCategory}</td>
                            <td><UserInfo email = {approval.labor} name = {approval.laborName}/></td>
                            <td>{approval.department}</td>
                            <td>
                                <span className = "font-weight-bold">
                                    {approval.workLogSubmitTime.substring(0, 10)}
                                </span>
                                {" "}
                                {approval.workLogSubmitTime.substring(11, 16)}
                            </td>
                            <td>
                                <span className = "font-weight-bold">
                                    {approval.startTime.substring(0, 10)}
                                </span>
                                {!approval.allDay?approval.startTime.substring(10, 16):null} 
                                {approval.allDay && approval.startTime.substring(0, 10) === approval.endTime.substring(0, 10)?null:" ~ "}
                                <span className = "font-weight-bold">
                                    {
                                        approval.startTime.substring(0, 10) === approval.endTime.substring(0, 10)?
                                        null:
                                        approval.endTime.substring(0, 10)
                                    }
                                </span>
                                {!approval.allDay?approval.endTime.substring(10, 16):null}
                            </td>
                            <td>
                                <button
                                    className = "btn btn-primary"
                                    type = "button"
                                    onClick = {() => {
                                        history.push(
                                            `/Projects/${approval.projectHashKey}/WorkInstructions/${approval.workInstructionHashKey}/WorkLogs/${approval.workLogHashKey}`
                                        );
                                    }}
                                    onKeyDown = {e => {
                                        if([" ", "Enter"].includes(e.key)){
                                            e.preventDefault();
                                            history.push(
                                                `/Projects/${approval.projectHashKey}/WorkInstructions/${approval.workInstructionHashKey}/WorkLogs/${approval.workLogHashKey}`
                                            );
                                        }
                                    }}
                                >
                                    →
                                </button>
                            </td>
                        </tr>
                        )}
                    </tbody>
                </table>
                </div>}
                {!showLoading && filteredApprovals.length?
                <Footer
                    length = {filteredApprovals.length}
                    pageNumbers = {pageNumbers}

                    currentPage = {currentPage}
                    setCurrentPage = {setCurrentPage}
                    itemsPerPage = {itemsPerPage}
                    setItemsPerPage = {setItemsPerPage}
                />
                :null}
            </div>
        </div>
    )
}